import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/home/home.vue'),
    meta: {
      keepAlive: false,
      isBack: false
    }
  },{
    path: '/Espace',
    name: 'HomeEspace',
    component: () => import('../pages/home/homeEspace.vue'),
    meta: {
      keepAlive: false,
      isBack: false
    }
  },{
    path: '/approve/core',
    name: 'approveCore',
    component: () => import('../pages/approve/core.vue'),
    meta: {
      keepAlive: false,
      isBack: false
    }
  },{
    path: '/approve/espace',
    name: 'approveEspace',
    component: () => import('../pages/approve/espace.vue'),
    meta: {
      keepAlive: false,
      isBack: false
    }
  },
  
]

const router = new VueRouter({
  routes
})

export default router